import "../styles/OurProgram.css";
import Card from "react-bootstrap/Card";
import Badge from "react-bootstrap/Badge";
import { Button, Col, Container, Row } from "react-bootstrap";
// import { SchoolProgram } from "../data";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { getUnit } from "../api_folder/api";

function OurProgram() {
  const [units, setUnits] = useState([]);

  const newData = {
    id_unit: "4",
    grup_unit: "1",
    name_unit: "TKIT Asy-Syukriyyah",
    logo_unit: "images/TUMBNAIL_TKIT.jpg",
    url: "/unit-tkit",
    sort_order: "1",
  };

  useEffect(() => {
    getUnit().then((res) => {
      setUnits(res.data);
    });
  }, []);

  const sortn = units.sort(
    (a, b) => a.sort_order - b.sort_order
  )

  const nfilter = sortn.filter(
    (unit) =>
      unit.sort_order >= 5
  );
  if (units.length > 0) {
    //   // filter to decrease card

    nfilter.unshift(newData);
    //   filteredUnits.push(newData1);
    //   filteredUnits.push(newData2);

    //   // rearranged units
    //   const asdfUnits = filteredUnits.splice(7, 7)[0];
    //   const dsaUnit = filteredUnits.splice(6, 6)[0];
    //   filteredUnits.splice(3, 0, asdfUnits);
    //   filteredUnits.splice(2, 0, dsaUnit);
  }


  return (
    <Container className="page2">
      <div>
        <h1 className="title text-center">Program kami</h1>

        <p className="text-center" style={{ color: "#697586" }}>
          Program sekolah pilihan di Asy-Syukriyyah Islamic School
        </p>
      </div>
      {nfilter.length > 0 && (
        <Row className="gap-xxl-5 gap-xs-5 gap-md-4 justify-content-md-center flex-nowrap flex-md-wrap scroll-x p-3">
          {nfilter?.map((e, i) => (
            <Col xs={11} md={5} lg={4} xl={3} xxl={3} key={i} className="p-2 d-flex">
              <Link
                to={e.url}
                className="d-flex flex-column p-1 mx-auto card list h-100 w-100"
                style={{ textDecoration: "none", color: "#000" }}
              >
                <Card.Img
                  variant="top"
                  src={"https://ppdb.asy-syukriyyah.sch.id/" + e.logo_unit}
                  alt={e.name_unit}
                  style={{
                    width: "100%",
                    aspectRatio: "1/1",
                    objectFit: "cover",
                    position: "relative",
                    borderTopLeftRadius: "25px",
                    borderTopRightRadius: "25px",
                  }}
                />
                <Card.Body className="d-flex flex-column flex-grow-1 justify-content-between mb-2">
                  <Card.Title>{e.name_unit}</Card.Title>
                  <Card.Text></Card.Text>
                  <Button
                    variant="success"
                    className="rounded-pill"
                    target="_blank"
                    href={e.url}
                  >
                    Daftar
                  </Button>
                  {/* <Badge pill bg="success">
                    Daftar
                  </Badge> */}
                </Card.Body>
              </Link>
            </Col>
          ))}
        </Row>
      )}
    </Container>
  );
}
export default OurProgram;
